import differenceInWeeks from 'date-fns/differenceInWeeks';
import fromUnixTime from 'date-fns/fromUnixTime';

const getters = {
	/**
	 * Get list of the filters
	 *
	 * @param {state} state The current state
	 *
	 * @returns {Array} The available filters array.
	 */
	filters(state) {
		const filters = {};

		Object.keys(state.filters).forEach((filter) => {
			filters[filter] = Array.isArray(state.filters[filter]) ? [...state.filters[filter]] : state.filters[filter];
		});

		return filters;
	},
	/**
	 * Get list of upsells to show to the user
	 *
	 * @param {state} state The current state
	 * @param {Object} getters The current getters
	 *
	 * @returns {Array} The available upsells array.
	 */
	availableUpsells(state, getters) {
		const available = state.upsells.filter((u) => {
			if ('doneForYou' === u.slug && !getters.shouldShowDoneForYouUpsell) {
				return false;
			}

			return true;
		});

		return available.length ? available : [];
	},
	/**
	 * Determine whether or not we have recommendations to show based on
	 * the recommendations in state and the recommendations that have already been dismissed
	 *
	 * @param {state} state The current state
	 *
	 * @returns {boolean} true if we have recommendations to show, false otherwise.
	 */
	hasRecommendations(state) {
		// If we have more recommendations than dismissed recommendations, we have recommendations.
		if (state.dismissedRecommendations.length < state.recommendations.length) {
			return true;
		}

		return state.recommendations.some((r) => !state.dismissedRecommendations.includes(r.slug));
	},
	/**
	 * Checks the account age to determine if the user is eligible for a 'done for you' campaign.
	 *
	 * @param {state} state The current state for playbooks
	 * @param {Object} getters The current getters for playbooks
	 * @param {state} rootState The current state for the root store
	 *
	 * @returns {bool} false if account is older than two weeks, true otherwise.
	 */
	shouldShowDoneForYouUpsell(state, getters, rootState) {
		const diff = differenceInWeeks(new Date(), fromUnixTime(rootState.user.created));

		// Show the 'done for you' upsell if the user's account is less than 2 weeks old.
		return 2 > diff;
	},
	/**
	 * Determines if there are any Gamified Playbooks.
	 *
	 * @param {state} state The current state for playbooks.
	 *
	 * @returns {bool} true if there is at least one gamified Playbook.
	 */
	hasGamifiedPlaybooks(state) {
		return state.playbooks.some((p) => {
			return p.tags.some((t) => {
				return 'Gamified' === t.name;
			});
		});
	},
};

export default getters;
